import plansNew from './plans-new';
import plansEdit from './plans-edit';

const route = {
	path: ':codeProject/plans',
	name: 'page-plan',
	meta: {
		title: 'Planes',
	},
	props: true,
	component: () => import('@/pages/plans/page-plan'),
	children: [
		plansNew,
		plansEdit,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/plans.js